var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTranslateIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2959 14.0033L12.6909 10.8008L11.0859 14.0033",
    stroke: "#BB8D0B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3789 13.4326H14.0189",
    stroke: "#BB8D0B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6909 16.4999C10.5909 16.4999 8.88086 14.7973 8.88086 12.6898C8.88086 10.5898 10.5834 8.87988 12.6909 8.87988C14.7909 8.87988 16.5009 10.5823 16.5009 12.6898C16.5009 14.7973 14.7984 16.4999 12.6909 16.4999Z",
    stroke: "#BB8D0B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.765 1.5H6.705C8.2575 1.5 9.00751 2.25001 8.97001 3.76501V6.705C9.00751 8.2575 8.2575 9.00752 6.705 8.97002H3.765C2.25 9.00002 1.5 8.24999 1.5 6.69749V3.75751C1.5 2.25001 2.25 1.5 3.765 1.5Z",
    stroke: "#BB8D0B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75984 4.38672H3.71484",
    stroke: "#BB8D0B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.23047 3.87695V4.38695",
    stroke: "#BB8D0B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99453 4.37988C5.99453 5.69238 4.96703 6.75737 3.70703 6.75737",
    stroke: "#BB8D0B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75859 6.75751C6.21109 6.75751 5.71609 6.465 5.37109 6",
    stroke: "#BB8D0B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 11.25C1.5 14.1525 3.8475 16.5 6.75 16.5L5.9625 15.1875",
    stroke: "#BB8D0B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 6.75C16.5 3.8475 14.1525 1.5 11.25 1.5L12.0375 2.8125",
    stroke: "#BB8D0B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslateIcon);
export default __webpack_public_path__ + "static/media/translate-icon.10a0849029326cc0d20575a765fa6a7a.svg";
export { ForwardRef as ReactComponent };